/*******************************************************************************
  ��  �� : Ȩ������ > ��������
  �ۼ��� : �ۿ���
  �ۼ��� : 2020-06-24
*******************************************************************************/
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

import { ApiResponse } from '@app/service/api-response';
import { UtilService } from '@app/service/util.service';
import { CommonService } from '@app/service/common.service';

import { HMemberService } from '@home/service/member.service';

import { O2OZCMS } from '@app/components/o2oz-cms/o2oz-cms.component';

@Component({
  selector: 'app-mypage-payment',
  templateUrl: './mypage-payment.component.html',
  styleUrls: ['./mypage-payment.component.scss']
})
export class MypagePaymentComponent extends O2OZCMS implements OnInit {

  /*******************************************************************************
    설명 : 전역 변수 선언부
  *******************************************************************************/
  public memberInfo: any = [];
  public memberPaymentList: any = [];

  /* 게시판 관련 변수 */
  public params: any = {
    boardSeq: 0,  // 게시판 순번
    no: 1,        // 현재 페이지
    row: 10,      // 페이지당 보여줄 갯수
  };
  public totalCount = 0;
  public maxSize: any = 10;

  /*******************************************************************************
    ��  �� : ������
    �Է°� : ����
    ���ϰ� : ����
  *******************************************************************************/
  constructor(
    router: Router,
    commonService: CommonService,
    activatedRoute: ActivatedRoute,
    toastrService: ToastrService,
    private utilService: UtilService,
    private formBuilder: FormBuilder,
    private memberService: HMemberService
  ) {
    // ���� Ŭ������ router ����
    super(router, commonService, activatedRoute, toastrService);
  }

  /*******************************************************************************
    ��  �� : ������ ó��
    �Է°� : ����
    ���ϰ� : ����
  *******************************************************************************/
  ngOnInit(): void {

    this.memberInfo$.subscribe( (member: any) => {
      if ( typeof member.memNo === 'undefined' )  {
        return false;
      } else {
        this.memberInfo = member;
        this.getMemberPaymentList();
      }
    });
  }

    /*******************************************************************************
    설  명 : 결제 정보 리스트 가져오기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  getMemberPaymentList() {
    // this.memberInfo.memNo = '131218';   // test

    this.memberService.getMemberPaymentList( this.memberInfo.memNo ).then( response => {
      if( response.ResultCode ) {
        this.memberPaymentList = response.data;
        this.totalCount = response.data.length;
      } else {
        this.toastrService.error( response.ResultMessage );
      }
    });
  }

  /*******************************************************************************
    설  명 : 페이지 선택 처리
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  loadPage( page ) {
    this.params.no = page;

    this.router.navigate(
    [location.pathname],
    {
      relativeTo: this.activatedRoute,
      queryParams: this.params,
      queryParamsHandling: '', // remove to replace all query params by provided
    });
  }

}
